/**
 * @generated SignedSource<<949604e8408f1df62216fd73a1e9a484>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pollVoteCreateMutation$variables = {
  option: string;
};
export type pollVoteCreateMutation$data = {
  readonly registerPollVote: {
    readonly id: string;
    readonly options: ReadonlyArray<{
      readonly id: string;
      readonly option: string;
      readonly votes: number;
    }>;
    readonly userPollVotes: ReadonlyArray<{
      readonly option: {
        readonly option: string;
      };
    }>;
  };
};
export type pollVoteCreateMutation = {
  response: pollVoteCreateMutation$data;
  variables: pollVoteCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "option"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "option",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "option",
        "variableName": "option"
      }
    ],
    "concreteType": "Poll",
    "kind": "LinkedField",
    "name": "registerPollVote",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "PollOption",
        "kind": "LinkedField",
        "name": "options",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "votes",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PollVote",
        "kind": "LinkedField",
        "name": "userPollVotes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PollOption",
            "kind": "LinkedField",
            "name": "option",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pollVoteCreateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pollVoteCreateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "468c3785b67d750e815f7d19878b0945",
    "id": null,
    "metadata": {},
    "name": "pollVoteCreateMutation",
    "operationKind": "mutation",
    "text": "mutation pollVoteCreateMutation(\n  $option: String!\n) {\n  registerPollVote(option: $option) {\n    id\n    options {\n      id\n      votes\n      option\n    }\n    userPollVotes {\n      option {\n        option\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8215bdd683184f0be409cc6e7edf9c1f";

export default node;
